import React from "react";
import PurchaseAccountList from "../Common/PurchaseAccountList";

const AdminPurchaseAccountsComp = () => (
  <PurchaseAccountList role="ADMIN" title="حساب خرید" />
);

export default AdminPurchaseAccountsComp;
